import { namespace } from "@root/core/constants/constant";
import table from "@store/reducers/pattern/table";

export const name = `${namespace}_voting_process`;

export default table(name);
